import { apiGet, apiPost, apiPut, apiDel } from 'app/shared-components/util/restAPI';

const API_NAME = 'CoreAPI2';
const API_BASE = '/x2/clientrecord';
const TEMPLATE_API_BASE = '/x2/recordtemplate';
const ENUM_API_BASE = '/x2/recordenum';


export const recordApi = {
  // Record operations
  getRecords: (clientId, filters = {}) => {
    const requestBody = {
      ...filters,
      fieldFilters: {
        ...filters.fieldFilters,
        clientId: clientId
      }
    };
    
    // Remove null date parameters to avoid breaking backend
    if (requestBody.createdAfter === null) {
      delete requestBody.createdAfter;
    }
    if (requestBody.createdBefore === null) {
      delete requestBody.createdBefore;
    }
    
    return apiPost(API_NAME, `${API_BASE}/filter`, { body: requestBody });
  },
  
  getRecord: (recordId) => 
    apiGet(API_NAME, `${API_BASE}/${recordId}`, {}),
  
  createRecord: (recordData) => 
    apiPut(API_NAME, API_BASE, { body: recordData }),
  
  updateRecord: (recordId, recordData) => 
    apiPut(API_NAME, `${API_BASE}/${recordId}`, { body: recordData }),
  
  deleteRecord: (recordId) => 
    apiDel(API_NAME, `${API_BASE}/${recordId}`, {}),
  
  // Schema operations
  getSchema: async (recordType) => {
    const result = await apiGet(API_NAME, `${API_BASE}/schema?recordType=${recordType}`, {});
    return result;
  },
  
  // Enum operations
  getSystemEnums: () => 
    apiGet(API_NAME, `${ENUM_API_BASE}/bysystem`, {}),
  
  getUserEnums: (ownerKey) => 
    apiGet(API_NAME, `${ENUM_API_BASE}/byowner/${ownerKey}`, {}),
  
  createEnum: (enumData) => 
    apiPut(API_NAME, ENUM_API_BASE, { body: enumData }),
  
  updateEnum: (enumId, enumData) => 
    apiPut(API_NAME, `${ENUM_API_BASE}/${enumId}`, { body: enumData }),
  
  deleteEnum: (enumId) => 
    apiDel(API_NAME, `${ENUM_API_BASE}/${enumId}`, {}),
  
  // Template operations
  getSystemTemplates: () => 
    apiGet(API_NAME, `${TEMPLATE_API_BASE}/bysystem`, {}),
  
  getUserTemplates: (ownerKey) => 
    apiGet(API_NAME, `${TEMPLATE_API_BASE}/byowner/${ownerKey}`, {}),
  
  getClientFacingTemplates: () => 
    apiGet(API_NAME, `${TEMPLATE_API_BASE}/clientfacing`, {}),
  
  getTemplate: (templateId) => 
    apiGet(API_NAME, `${TEMPLATE_API_BASE}/${templateId}`, {}),
  
  createTemplate: (templateData) => 
    apiPut(API_NAME, TEMPLATE_API_BASE, { body: templateData }),
  
  updateTemplate: (templateId, templateData) => 
    apiPut(API_NAME, `${TEMPLATE_API_BASE}/${templateId}`, { body: templateData }),
  
  deleteTemplate: (templateId) => 
    apiDel(API_NAME, `${TEMPLATE_API_BASE}/${templateId}`, {}),
  
  // Version history operations
  getVersionHistory: (recordId) => 
    apiGet(API_NAME, `${API_BASE}/${recordId}/versions`, {}),
  
  revertRecord: (recordId, versionId) => 
    apiPost(API_NAME, `${API_BASE}/${recordId}/revert?versionId=${versionId}`, {}),
  
  // Pre-population operations
  getPrePopulatedData: (templateId, clientId) => 
    apiGet(API_NAME, `${API_BASE}/templated/prepopulate?templateId=${templateId}&clientId=${clientId}`, {}),
  
  // Placeholder validation operations
  validatePlaceholderData: (clientId, templateIds) => 
    apiPost(API_NAME, `${TEMPLATE_API_BASE}/validateplaceholders`, { 
      body: { clientId, templateIds } 
    }),
  
  // Provider operations
  createReleaseWithFile: (providerId, fileId) => {
    // #316: the backend route declares `fileId` as a query param
    // (ClientRecord.createReleaseWithFile, queryParams = {"fileId"}), so the
    // query string needs a '?' separator — without it `fileId` was glued onto
    // the route segment and never parsed as a query param.
    const queryString = new URLSearchParams({ fileId }).toString();
    const url = `${API_BASE}/${providerId}/provider/releasewithfile?${queryString}`;
    return apiPost(API_NAME, url, {});
  },

  createReleaseWithTask: (providerId, requestData) => {
    const url = `${API_BASE}/${providerId}/provider/releasewithtask`;
    return apiPost(API_NAME, url, { body: requestData });
  },
  
  // Provider signature operations
  signRecord: (recordId, signatureData) => 
    apiPost(API_NAME, `${API_BASE}/${recordId}/sign`, { body: signatureData }),
  
  unsignRecord: (recordId) => 
    apiPost(API_NAME, `${API_BASE}/${recordId}/unsign`, {})
};